import React from 'react'
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import OfficerController from "../../../../../services/system/staff/officer-controller";
function withParams(Component) {
    return (props) => <Component {...props} params={useSearchParams()} />;
}
class DetailStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null,
            endDate: null,
            name: "",
            des: "",
            status: "",

        };
    }
    formatMoney(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    componentWillMount() {
        const [searchparams] = this.props.params;
        let staffId = searchparams.get("id");
        OfficerController.detail(staffId, res => {
            if (res.success){
                let data = res.data
                this.setState(res.data)
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getDegree(degree){
        if (degree == "TRUNG_CAP"){
            return "Trung cấp";
        }else if (degree == "CAO_DANG"){
            return "Cao đẳng";
        }else if (degree == "DAI_HOC"){
            return "Đại học";
        }else if (degree == "THAC_SI"){
            return "Thạc sĩ";
        }else if (degree == "TIEN_SI"){
            return "Tiến sĩ";
        }else if (degree == "PGS_TIEN_SI"){
            return "PGS.Tiến sĩ";
        }else if (degree == "GIAO_SU"){
            return "Giáo sư";
        }
        return ""
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-staff" parentClass="staff-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thông tin cán bộ"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Thông tin cán bộ</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin tài khoản</div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã cán bộ</label>
                                                <label className="col-8 label-item pl-0">{this.state.code}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">

                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên đăng nhập</label>
                                                <label
                                                    className="pl-0 font-weight-bold kt-margin-b-10-tablet-and-mobile pt-1">
                                                    {this.state.username}
                                                </label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái tài khoản</label>
                                                <label
                                                    className="pl-0 font-weight-bold kt-margin-b-10-tablet-and-mobile pt-1">
                                                    {this.state.status=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Khóa</span> : <span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>}
                                                </label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">

                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Thông tin cán bộ</div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên</label>
                                                <label className="label-item pl-0">{this.state.fullName}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tổ bộ môn</label>
                                                <label className="label-item pl-0">{this.state.departmentSubject}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email</label>
                                                <label className="label-item pl-0">{this.state.email}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại</label>
                                                <label className="label-item pl-0">{this.state.phone1}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh</label>
                                                <label className="label-item pl-0">{this.state.birthday}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giới tính</label>
                                                <label className="label-item pl-0">{this.state.gender=="MALE"? "Nam": "Nữ"}</label>

                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số CMND/CCCD</label>
                                                <label className="label-item pl-0">{this.state.identifyCard}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày cấp</label>
                                                <label className="label-item pl-0">{this.state.dateIdentifyCard}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nơi cấp</label>
                                                <label className="label-item pl-0">{this.state.provinceIdentifyCard}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc</label>
                                                <label className="label-item pl-0">{this.state.ethnic=="KINH"? "Kinh": "Khác"}</label>
                                            </div>
                                            <div className="ol-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo</label>
                                                <label className="label-item pl-0">{this.state.religion=="NO"? "Không": "Có"}</label>
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Quê quán</div>
                                            </div>
                                            <div className="ol-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa chỉ</label>
                                                <label className="label-item pl-0">{this.state.addressUsually}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Xã/Phường</label>
                                                <label className="label-item pl-0">{this.state.wardRes?.fullName}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Quận/Huyện</label>
                                                <label className="label-item pl-0">{this.state.districtRes?.fullName}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tỉnh/Thành phố</label>
                                                <label className="label-item pl-0">{this.state.provinceRes?.fullName}</label>
                                            </div>
                                            <div className="col-12 d-flex mb-2">
                                                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Hợp đồng</div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày vào trường</label>
                                                <label className="label-item pl-0">{this.state.schoolDay}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Bằng cấp</label>
                                                <label className="label-item pl-0">{this.getDegree(this.state.degree)}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số sổ BHXH</label>
                                                <label className="label-item pl-0">{this.state.socialInsuranceNumber}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Vị trí làm việc</label>
                                                <label className="label-item pl-0">{this.state.job}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Loại hợp đồng</label>
                                                <label className="label-item pl-0">{this.state.contract=="BIEN_CHE"?"Biên chế": "Hợp đồng"}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0">Trạng thái công việc</label>
                                                {this.state.jobState=="STOP" ? <span className="badge badge-danger" style={{color: "white"}}>Dừng làm việc</span> : <span className="badge badge-success" style={{color: "white"}}>Đang làm việc</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default withParams(DetailStaff)
